import type { Moment } from "moment";

export type ScrapMixFilterType =
  | "Shift"
  | "Crew"
  | "Grade"
  | "Recipe"
  | "Operator"
  | "ChargeNumber"
  | "Heat";

export interface ScrapMixFilters {
  from: Moment;
  to: Moment;
  excludeOutOfRangeLayers: boolean;
  shifts: string[];
  crews: string[];
  gradeIds: string[];
  recipeFamilyIds: string[];
  operatorIds: string[];
  chargeNumbers: string[];
  heatNames: string[];
}

export interface LayerWeightLimits {
  min: number;
  max: number;
}

export const DEFAULT_LAYER_WEIGHT_LIMITS: LayerWeightLimits = {
  min: -4000,
  max: 10000,
};

export interface ScrapMixSummary {
  ChargeCount: number;
  HeatCount: number;
  RecipeCount: number;
  AverageChargeWeight: number;
}

export interface ScrapMixStatistic {
  Level: "recipe" | "charge";
  RecipeFamilyId: number;
  RecipeName: string;
  ChargeNumber: number | null;
  SampleCount: number;
  CommodityId: number | null;
  CommodityName: string;
  CommodityColor: string | null;
  IsTotal: boolean;
  IsUnexpectedMaterial: boolean;
  AverageWeight: number;
  MinimumWeight: number;
  MaximumWeight: number;
  MinimumChargeId: number | null;
  MaximumChargeId: number | null;
  MinimumHeatName: string | null;
  MaximumHeatName: string | null;
}

export interface ScrapMixFilterOption {
  FilterType: ScrapMixFilterType;
  Value: string;
  Label: string;
}

export interface ScrapMixAnalysis {
  summary: ScrapMixSummary;
  statistics: ScrapMixStatistic[];
  filterOptions: ScrapMixFilterOption[];
}

export const EMPTY_SCRAP_MIX_SUMMARY: ScrapMixSummary = {
  ChargeCount: 0,
  HeatCount: 0,
  RecipeCount: 0,
  AverageChargeWeight: 0,
};
